import { Link } from 'react-router-dom';
import type { Obligation, Reminder } from '../types';
import { CATEGORY_EMOJI } from '../types';
import { getUrgency, daysUntil } from '../lib/status';
import { useAppData } from '../store';
import { formatUSD } from '../lib/format';

function StatusDot({ urgency }: { urgency: 'overdue' | 'due_soon' | 'ok' }) {
  const icon = urgency === 'overdue' ? '🔴' : urgency === 'due_soon' ? '🟠' : '🟢';
  return <span className="status-dot">{icon}</span>;
}

function dueLabel(obligation: Obligation): string {
  const d = daysUntil(obligation.due_date);
  if (d < 0) return `${Math.abs(d)} day${Math.abs(d) === 1 ? '' : 's'} overdue`;
  if (d === 0) return 'Due today';
  if (d === 1) return 'Due tomorrow';
  return `Due in ${d} days`;
}

export default function ObligationCard({
  obligation,
  reminders = [],
}: {
  obligation: Obligation;
  reminders?: Reminder[];
}) {
  const { getProperty } = useAppData();
  const property = getProperty(obligation.property_id);
  const urgency = getUrgency(obligation, reminders);

  return (
    <Link to={`/obligations/${obligation.id}`} className={`card obligation-card urgency-${urgency}`}>
      <div className="obligation-card-main">
        <div className="obligation-card-title">
          {property && <span className="emoji">{CATEGORY_EMOJI[property.category]}</span>}
          <span className="name">{obligation.name}</span>
        </div>
        <div className="obligation-card-sub muted">
          {property ? property.name : 'No property'}
          {obligation.amount ? ` · ${formatUSD(obligation.amount)}` : ''}
        </div>
      </div>
      <div className="obligation-card-meta">
        <StatusDot urgency={urgency} />
        <span className="due-label">{dueLabel(obligation)}</span>
      </div>
    </Link>
  );
}
